/**
 * iVCEBlast Validation Schema
 */

import { z } from 'zod';
import { evaluateExpression } from '../shared';

export const schema = z.object({
  project: z.string().min(1, 'Project name is required'),
  title: z.string().min(1, 'Title is required'),
  mass: z.coerce.number().min(0.001, 'Mass must be > 0'),
  LHV: z.coerce.number().min(0.001, 'LHV must be > 0'),
  mf: z.coerce.number().min(0.001, 'Mach number must be > 0').max(20, 'Mach number must be <= 20'),
  R: z.coerce.number().min(0.001, 'Standoff distance must be > 0'),
  Confinement: z.enum(['Confined', 'UnConfined']),
  V: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n >= 0;
  }, 'Volume must be a valid expression greater than or equal to 0'),
  A: z.string().refine(s => {
    const n = evaluateExpression(s);
    return n !== null && n >= 0;
  }, 'Surface area must be a valid expression greater than or equal to 0')
});

export type FormValues = z.infer<typeof schema>;
export type ParsedValues = z.output<typeof schema>;
